import { render, staticRenderFns } from "./ListPlus.vue?vue&type=template&id=6a28ce8a&scoped=true"
import script from "./ListPlus.vue?vue&type=script&lang=js"
export * from "./ListPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a28ce8a",
  null
  
)

export default component.exports